import { Injectable } from '@angular/core';
import { Router, UrlSegmentGroup, UrlTree } from '@angular/router';
import { RouteConfiguration } from '../models/config.model';

@Injectable({ providedIn: 'root' })
export class RoutingService {
  public routes: RouteConfiguration[];
  public unkownRoute: RouteConfiguration;

  constructor(private router: Router) {
    this.unkownRoute = new RouteConfiguration({
      designation: 'unknown',
    });
  }
  public getRouteByName(routeName: string): RouteConfiguration {
    return this.routes.find((r) => r.designation === routeName);
  }
  public navigateName(routeName: string): Promise<boolean> {
    return this.navigate(this.getRouteByName(routeName));
  }

  public navigate(route: RouteConfiguration, clearCurrentOutlet?: boolean): Promise<boolean> {
    let outletToClear: string = null;
    if (clearCurrentOutlet) {
      const currConfig: RouteConfiguration = this.getCurrentConfig();
      if (route?.designation !== currConfig.designation && currConfig.outlet) {
        outletToClear = currConfig.outlet + '": null';
      }
    }
    if (route?.outlet) {
      let naviString: string = '[{ "outlets": { "';
      if (outletToClear) {
        naviString += outletToClear + ', "' + route.outlet + '": "' + route.path + '"';
      } else {
        naviString += route.outlet + '": "' + route.path + '"';
      }

      naviString += '}}]';

      const naviObject = JSON.parse(naviString);
      return this.router.navigate(naviObject);
    } else {
      return this.router.navigate([route?.path]);
    }
  }

  public getCurrentConfig(): RouteConfiguration {
    let result: RouteConfiguration;
    const urlTree: UrlTree = this.router.parseUrl(this.router.url);
    const rootSegmentGroup: UrlSegmentGroup = urlTree.root;
    if (rootSegmentGroup && rootSegmentGroup.numberOfChildren) {
      for (const childKey of Object.keys(rootSegmentGroup.children)) {
        const child = rootSegmentGroup.children[childKey];
        for (const route of this.routes) {
          //currently are only 2 segments needed
          const fullChildPath: string =
            child.segments[0].path + (child.segments.length === 2 ? '/' + child.segments[1].path : '');
          if ((!route.outlet || route.outlet === childKey) && route.path === fullChildPath) {
            result = route;
            break;
          }
        }
        if (result) {
          break;
        }
      }
    }
    if (!result) {
      result = this.unkownRoute;
    }

    return result;
  }
}
